var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9241 6.56283H11.7341C11.5241 4.34033 9.75078 2.56116 7.52828 2.35699V1.16699C7.52828 0.927826 7.32995 0.729492 7.09078 0.729492C6.85161 0.729492 6.65328 0.927826 6.65328 1.16699V2.35699C4.43078 2.56699 2.65161 4.34033 2.44745 6.56283H1.25745C1.01828 6.56283 0.819946 6.76116 0.819946 7.00033C0.819946 7.23949 1.01828 7.43783 1.25745 7.43783H2.44745C2.65745 9.66033 4.43078 11.4395 6.65328 11.6437V12.8337C6.65328 13.0728 6.85161 13.2712 7.09078 13.2712C7.32995 13.2712 7.52828 13.0728 7.52828 12.8337V11.6437C9.75078 11.4337 11.5299 9.66033 11.7341 7.43783H12.9241C13.1633 7.43783 13.3616 7.23949 13.3616 7.00033C13.3616 6.76116 13.1633 6.56283 12.9241 6.56283ZM7.09078 8.82032C6.08745 8.82032 5.27078 8.00366 5.27078 7.00033C5.27078 5.99699 6.08745 5.18033 7.09078 5.18033C8.09411 5.18033 8.91078 5.99699 8.91078 7.00033C8.91078 8.00366 8.09411 8.82032 7.09078 8.82032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPlace);
export default __webpack_public_path__ + "static/media/inPlace.dc39a36f1238c2220c88278052bd7f08.svg";
export { ForwardRef as ReactComponent };